export const getImageUrl = (path: string) =>
  `${process.env.REACT_APP_SERVER_URL}${path}`;
